import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasSession, isSuperAdmin, needsPasswordChange } from "./auth/authSession";
import CompanyAssignedRoute from "./CompanyAssignedRoute";
import DepartmentQueryGuard from "./DepartmentQueryGuard";
import { PermissionContext } from "./PermissionContext";
import { hasLaneAccess } from "./utils/procurementMode";

const LaneProtectedRoute = ({ children, lane }) => {
  const { permissions, loading } = useContext(PermissionContext);
  const location = useLocation();
  const resolvedLane =
    lane ||
    (location.pathname.startsWith("/non-inventory")
      ? "NON_INVENTORY"
      : "INVENTORY");

  if (!hasSession()) {
    return <Navigate to="/login" replace />;
  }

  if (needsPasswordChange()) {
    return <Navigate to="/change-password" replace />;
  }

  if (loading) return <div>Loading...</div>;

  if (!isSuperAdmin() && !hasLaneAccess(permissions, resolvedLane)) {
    return <Navigate to="/home" replace />;
  }

  return (
    <CompanyAssignedRoute>
      <DepartmentQueryGuard lane={resolvedLane}>{children}</DepartmentQueryGuard>
    </CompanyAssignedRoute>
  );
};

export default LaneProtectedRoute;
